import { Button, Image } from '@wix/design-system'
import { type FreeTextQuestionContentComponent, useContent, useNext } from '@wix/funnel-builder-lizard'
import classNames from 'classnames'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { useFlowContext } from '../../../hooks/useFlowContext'
import s from './TemplateSaved.scss'

export type Content = {
  title: string
  subtitle: string
  button: string
  question: FreeTextQuestionContentComponent<Record<string, never>>
}

export const HarmonyTemplateSaved: FC = () => {
  const { content } = useContent<Content>()
  const pageLogger = usePageLogger()
  const next = useNext()
  const [flowContext] = useFlowContext()

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const { templateImage = '' } = flowContext?.metadata || { templateImage: '' }

  return (
    <div className={s.TemplateSaved}>
      <div className={s.TemplateSaved__imgContainer}>
        <Image
          className={classNames({ [s.TemplateSaved__imgFallBack]: !templateImage })}
          borderRadius="4px"
          src={templateImage}
          alt=""
        />
      </div>
      <span className={s.TemplateSaved__title}>{content.title}</span>
      <span className={s.TemplateSaved__subtitle}>{content.subtitle}</span>
      <Button
        size="large"
        className={s.TemplateSaved__continueBtn}
        onClick={() => {
          next({ [content.question.questionKey]: { skipped: true } })
        }}
      >
        {content.button}
      </Button>
    </div>
  )
}
